import { DateFormatKeys, DateFormats } from "./date-formats";

export class YearLogic {
  static isYearValid(
    year: number,
    minYear?: number | undefined,
    maxYear?: number | undefined,
  ): boolean {
    const minYearIsValid: boolean = minYear === undefined || year >= minYear;
    const maxYearIsValid: boolean = maxYear === undefined || year <= maxYear;

    return minYearIsValid && maxYearIsValid;
  }

  static isYearTwoDigitFormatted(year: string): boolean {
    return DateFormats[DateFormatKeys.TwoDigitYear].test(year);
  }

  static isYearFourDigitFormatted(year: string): boolean {
    return DateFormats[DateFormatKeys.FourDigitYear].test(year);
  }
}
